import React, { useState } from 'react';
import { Button, Flex, Text } from 'core/components';
import Markdown from 'app/components/markdown/Markdown';
import { ClampedReasoning, ReasoningContent, ReasoningDetails } from '../KaizenChatSession.styles';

// Reasoning runs anywhere from a sentence to several pages; clamp past this and offer a toggle.
const CLAMP_CHARS = 700;

const ReasoningBlock = ({ text, label = 'reasoning' }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [isExpanded, setIsExpanded] = useState(false);

  if (!text) {
    return null;
  }

  const isLong = text.length > CLAMP_CHARS;

  return (
    <>
      <Button
        small
        minimal
        color="muted"
        icon={isOpen ? 'caret-up' : 'caret-down'}
        style={{ alignSelf: 'flex-start' }}
        text={
          <Flex alignItems="center" gap="6px">
            <Text small>
              {isOpen ? 'Hide' : 'Show'} {label}
            </Text>
            <Text small muted>
              {text.length.toLocaleString()} chars
            </Text>
          </Flex>
        }
        onClick={() => setIsOpen((prev) => !prev)}
      />

      {isOpen && (
        <ReasoningDetails>
          <ClampedReasoning $clamped={isLong && !isExpanded}>
            <ReasoningContent>
              <Markdown>{text}</Markdown>
            </ReasoningContent>
          </ClampedReasoning>
          {isLong && (
            <Button
              small
              minimal
              color="muted"
              text={isExpanded ? 'Show less' : 'Show more'}
              onClick={() => setIsExpanded((prev) => !prev)}
            />
          )}
        </ReasoningDetails>
      )}
    </>
  );
};

export default ReasoningBlock;
